console.log("SKY Configurator loading...");

// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 0,      // Euromääräinen lisäys/vähennys
  percentAdjustment: 12    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.SkyProductConfig = {
  variantIds: {
    base: 51895692984658,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 300,
    maxWidth: 1500,
    minHeight: 200,
    maxHeight: 4000,
    maxArea: 6.0,
  },
  profiles: {
    white9016: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    white9016structure: {
      name: "Valkoinen RAL9016 structure",
      color: "#F8F8F8",
    },
    white9010structure: {
      name: "Valkoinen RAL9010 structure",
      color: "#F1F1F1",
    },
    creme9001structure: { name: "Creme RAL9001 structure", color: "#F6F0E7" },
    beige1015: { name: "Beige RAL1015", color: "#EBCC90" },
    bronzeAnodized: { name: "Pronssi anodisoitu", color: "#8E7C67" },
    silverAnodized: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    lightGray7040: {
      name: "Vaaleanharmaa RAL7040 structure",
      color: "#C0C0C0",
    },
    darkGrayDB703: { name: "Tummanharmaa DB 703", color: "#575556" },
    anthracite7016: { name: "Antrasiitti RAL7016 structure", color: "#3C3C3C" },
    black9005structure: { name: "Musta RAL9005 structure", color: "#0A0A0A" },
  },
  priceTable: {
  S: {
    800: {
      400: 130,
      500: 140,
      600: 149,
      700: 159,
      800: 166,
      900: 183,
      1000: 191,
      1100: 202,
      1200: 212,
      1300: 224,
      1400: 231,
      1500: 243,
    },
    900: {
      400: 133,
      500: 143,
      600: 153,
      700: 164,
      800: 173,
      900: 189,
      1000: 199,
      1100: 210,
      1200: 222,
      1300: 231,
      1400: 243,
      1500: 254,
    },
    1000: {
      400: 137,
      500: 146,
      600: 157,
      700: 168,
      800: 178,
      900: 195,
      1000: 205,
      1100: 218,
      1200: 229,
      1300: 239,
      1400: 250,
      1500: 261,
    },
    1100: {
      400: 140,
      500: 151,
      600: 162,
      700: 173,
      800: 183,
      900: 199,
      1000: 212,
      1100: 224,
      1200: 237,
      1300: 248,
      1400: 258,
      1500: 272,
    },
    1200: {
      400: 144,
      500: 153,
      600: 164,
      700: 176,
      800: 189,
      900: 208,
      1000: 218,
      1100: 231,
      1200: 243,
      1300: 256,
      1400: 267,
      1500: 280,
    },
    1300: {
      400: 147,
      500: 162,
      600: 176,
      700: 185,
      800: 199,
      900: 212,
      1000: 226,
      1100: 239,
      1200: 250,
      1300: 263,
      1400: 277,
      1500: 291,
    },
    1400: {
      400: 151,
      500: 164,
      600: 178,
      700: 191,
      800: 205,
      900: 218,
      1000: 231,
      1100: 245,
      1200: 258,
      1300: 272,
      1400: 285,
      1500: 298,
    },
    1500: {
      400: 153,
      500: 171,
      600: 183,
      700: 197,
      800: 210,
      900: 226,
      1000: 239,
      1100: 254,
      1200: 267,
      1300: 280,
      1400: 294,
      1500: 307,
    },
    1600: {
      400: 158,
      500: 173,
      600: 189,
      700: 202,
      800: 218,
      900: 231,
      1000: 245,
      1100: 258,
      1200: 275,
      1300: 288,
      1400: 304,
      1500: 318,
    },
    1700: {
      400: 162,
      500: 178,
      600: 191,
      700: 208,
      800: 224,
      900: 237,
      1000: 254,
      1100: 267,
      1200: 282,
      1300: 296,
      1400: 311,
      1500: 326,
    },
    1800: {
      400: 164,
      500: 180,
      600: 197,
      700: 212,
      800: 226,
      900: 243,
      1000: 258,
      1100: 275,
      1200: 291,
      1300: 304,
      1400: 321,
      1500: 336,
    },
    1900: {
      400: 167,
      500: 185,
      600: 202,
      700: 218,
      800: 234,
      900: 250,
      1000: 267,
      1100: 280,
      1200: 298,
      1300: 311,
      1400: 330,
      1500: 344,
    },
    2000: {
      400: 172,
      500: 189,
      600: 205,
      700: 224,
      800: 239,
      900: 256,
      1000: 272,
      1100: 288,
      1200: 304,
      1300: 323,
      1400: 340,
      1500: 355,
    },
    2100: {
      400: 176,
      500: 195,
      600: 210,
      700: 226,
      800: 245,
      900: 261,
      1000: 280,
      1100: 296,
      1200: 311,
      1300: 330,
      1400: 347,
      1500: 367,
    },
    2200: {
      400: 178,
      500: 197,
      600: 215,
      700: 231,
      800: 250,
      900: 270,
      1000: 285,
      1100: 304,
      1200: 321,
      1300: 340,
      1400: 357,
      1500: 374,
    },
    2300: {
      400: 182,
      500: 202,
      600: 222,
      700: 237,
      800: 256,
      900: 275,
      1000: 294,
      1100: 311,
      1200: 330,
      1300: 347,
      1400: 367,
      1500: 385,
    },
    2400: {
      400: 185,
      500: 205,
      600: 224,
      700: 243,
      800: 263,
      900: 280,
      1000: 298,
      1100: 318,
      1200: 340,
      1300: 357,
      1400: 374,
      1500: 393,
    },
    2500: {
      400: 189,
      500: 210,
      600: 229,
      700: 248,
      800: 267,
      900: 288,
      1000: 307,
      1100: 326,
      1200: 344,
      1300: 367,
      1400: 385,
      1500: 403,
    },
    2600: {
      400: 192,
      500: 212,
      600: 234,
      700: 254,
      800: 275,
      900: 294,
      1000: 315,
      1100: 334,
      1200: 353,
      1300: 374,
      1400: 393,
      1500: 415,
    },
    2700: {
      400: 196,
      500: 218,
      600: 239,
      700: 258,
      800: 280,
      900: 298,
      1000: 321,
      1100: 342,
      1200: 360,
      1300: 382,
      1400: 403,
      1500: 422,
    },
    2800: {
      400: 199,
      500: 224,
      600: 243,
      700: 263,
      800: 285,
      900: 307,
      1000: 328,
      1100: 347,
      1200: 369,
      1300: 390,
      1400: 412,
      1500: 433,
    },
    2900: {
      400: 202,
      500: 226,
      600: 248,
      700: 270,
      800: 291,
      900: 311,
      1000: 334,
      1100: 355,
      1200: 376,
      1300: 399,
      1400: 420,
      1500: 441,
    },
    3000: {
      400: 206,
      500: 231,
      600: 254,
      700: 275,
      800: 296,
      900: 321,
      1000: 342,
      1100: 363,
      1200: 385,
      1300: 408,
      1400: 431,
      1500: 452,
    },
    3100: {
      400: 210,
      500: 234,
      600: 258,
      700: 280,
      800: 304,
      900: 326,
      1000: 347,
      1100: 372,
      1200: 393,
      1300: 418,
      1400: 439,
      1500: 464,
    },
    3200: {
      400: 213,
      500: 239,
      600: 263,
      700: 285,
      800: 309,
      900: 330,
      1000: 355,
      1100: 379,
      1200: 401,
      1300: 425,
      1400: 449,
      1500: 471,
    },
    3300: {
      400: 216,
      500: 243,
      600: 267,
      700: 291,
      800: 315,
      900: 340,
      1000: 363,
      1100: 388,
      1200: 408,
      1300: 433,
      1400: 456,
      1500: 482,
    },
    3400: {
      400: 221,
      500: 248,
      600: 272,
      700: 296,
      800: 321,
      900: 344,
      1000: 369,
      1100: 393,
      1200: 418,
      1300: 441,
      1400: 468,
      1500: 492,
    },
    3500: {
      400: 224,
      500: 250,
      600: 277,
      700: 302,
      800: 326,
      900: 350,
      1000: 376,
      1100: 401,
      1200: 425,
      1300: 452,
      1400: 475,
      1500: 500,
    },
    3600: {
      400: 226,
      500: 256,
      600: 280,
      700: 307,
      800: 330,
      900: 357,
      1000: 385,
      1100: 408,
      1200: 433,
      1300: 460,
      1400: 485,
      1500: 512,
    },
    3700: {
      400: 230,
      500: 258,
      600: 285,
      700: 311,
      800: 340,
      900: 363,
      1000: 390,
      1100: 418,
      1200: 441,
      1300: 468,
      1400: 495,
      1500: 519,
    },
    3800: {
      400: 234,
      500: 263,
      600: 291,
      700: 318,
      800: 344,
      900: 372,
      1000: 399,
      1100: 425,
      1200: 449,
      1300: 475,
      1400: 502,
      1500: 530,
    },
    3900: {
      400: 238,
      500: 270,
      600: 296,
      700: 323,
      800: 350,
      900: 376,
      1000: 403,
      1100: 431,
      1200: 456,
      1300: 485,
      1400: 514,
      1500: 540,
    },
    4000: {
      400: 244,
      500: 272,
      600: 298,
      700: 328,
      800: 355,
      900: 385,
      1000: 412,
      1100: 439,
      1200: 466,
      1300: 495,
      1400: 521,
      1500: 548,
    },
  },
  0: {
    800: {
      400: 144,
      500: 157,
      600: 165,
      700: 177,
      800: 185,
      900: 204,
      1000: 212,
      1100: 224,
      1200: 237,
      1300: 248,
      1400: 257,
      1500: 270,
    },
    900: {
      400: 149,
      500: 159,
      600: 171,
      700: 183,
      800: 192,
      900: 210,
      1000: 222,
      1100: 234,
      1200: 245,
      1300: 257,
      1400: 270,
      1500: 281,
    },
    1000: {
      400: 152,
      500: 162,
      600: 175,
      700: 185,
      800: 197,
      900: 215,
      1000: 228,
      1100: 243,
      1200: 255,
      1300: 265,
      1400: 278,
      1500: 290,
    },
    1100: {
      400: 157,
      500: 167,
      600: 179,
      700: 192,
      800: 204,
      900: 222,
      1000: 237,
      1100: 248,
      1200: 263,
      1300: 275,
      1400: 288,
      1500: 302,
    },
    1200: {
      400: 160,
      500: 171,
      600: 183,
      700: 195,
      800: 210,
      900: 230,
      1000: 243,
      1100: 257,
      1200: 270,
      1300: 283,
      1400: 296,
      1500: 311,
    },
    1300: {
      400: 164,
      500: 179,
      600: 195,
      700: 206,
      800: 222,
      900: 237,
      1000: 252,
      1100: 265,
      1200: 278,
      1300: 293,
      1400: 308,
      1500: 323,
    },
    1400: {
      400: 167,
      500: 183,
      600: 197,
      700: 212,
      800: 228,
      900: 243,
      1000: 257,
      1100: 272,
      1200: 288,
      1300: 302,
      1400: 317,
      1500: 331,
    },
    1500: {
      400: 172,
      500: 189,
      600: 204,
      700: 218,
      800: 234,
      900: 252,
      1000: 265,
      1100: 281,
      1200: 296,
      1300: 311,
      1400: 326,
      1500: 341,
    },
    1600: {
      400: 176,
      500: 192,
      600: 210,
      700: 224,
      800: 243,
      900: 257,
      1000: 272,
      1100: 288,
      1200: 306,
      1300: 321,
      1400: 339,
      1500: 353,
    },
    1700: {
      400: 179,
      500: 197,
      600: 212,
      700: 230,
      800: 248,
      900: 263,
      1000: 281,
      1100: 296,
      1200: 314,
      1300: 329,
      1400: 347,
      1500: 361,
    },
    1800: {
      400: 183,
      500: 201,
      600: 218,
      700: 237,
      800: 252,
      900: 270,
      1000: 288,
      1100: 306,
      1200: 323,
      1300: 339,
      1400: 356,
      1500: 374,
    },
    1900: {
      400: 188,
      500: 206,
      600: 224,
      700: 243,
      800: 261,
      900: 278,
      1000: 296,
      1100: 311,
      1200: 331,
      1300: 347,
      1400: 368,
      1500: 383,
    },
    2000: {
      400: 191,
      500: 210,
      600: 228,
      700: 248,
      800: 265,
      900: 283,
      1000: 302,
      1100: 321,
      1200: 339,
      1300: 359,
      1400: 376,
      1500: 394,
    },
    2100: {
      400: 195,
      500: 215,
      600: 234,
      700: 252,
      800: 272,
      900: 290,
      1000: 311,
      1100: 329,
      1200: 347,
      1300: 368,
      1400: 386,
      1500: 407,
    },
    2200: {
      400: 198,
      500: 218,
      600: 239,
      700: 257,
      800: 278,
      900: 298,
      1000: 317,
      1100: 339,
      1200: 356,
      1300: 376,
      1400: 399,
      1500: 416,
    },
    2300: {
      400: 202,
      500: 224,
      600: 245,
      700: 263,
      800: 283,
      900: 306,
      1000: 326,
      1100: 347,
      1200: 368,
      1300: 386,
      1400: 407,
      1500: 427,
    },
    2400: {
      400: 206,
      500: 228,
      600: 248,
      700: 270,
      800: 293,
      900: 311,
      1000: 331,
      1100: 353,
      1200: 376,
      1300: 399,
      1400: 416,
      1500: 436,
    },
    2500: {
      400: 210,
      500: 234,
      600: 255,
      700: 275,
      800: 296,
      900: 321,
      1000: 341,
      1100: 361,
      1200: 383,
      1300: 407,
      1400: 427,
      1500: 448,
    },
    2600: {
      400: 213,
      500: 237,
      600: 261,
      700: 281,
      800: 306,
      900: 326,
      1000: 350,
      1100: 370,
      1200: 392,
      1300: 416,
      1400: 436,
      1500: 460,
    },
    2700: {
      400: 217,
      500: 243,
      600: 265,
      700: 288,
      800: 311,
      900: 331,
      1000: 356,
      1100: 379,
      1200: 401,
      1300: 425,
      1400: 448,
      1500: 469,
    },
    2800: {
      400: 222,
      500: 248,
      600: 270,
      700: 293,
      800: 317,
      900: 341,
      1000: 366,
      1100: 386,
      1200: 409,
      1300: 434,
      1400: 456,
      1500: 481,
    },
    2900: {
      400: 225,
      500: 252,
      600: 275,
      700: 298,
      800: 323,
      900: 347,
      1000: 370,
      1100: 394,
      1200: 419,
      1300: 442,
      1400: 467,
      1500: 490,
    },
    3000: {
      400: 229,
      500: 257,
      600: 281,
      700: 306,
      800: 329,
      900: 356,
      1000: 379,
      1100: 403,
      1200: 427,
      1300: 454,
      1400: 478,
      1500: 502,
    },
    3100: {
      400: 232,
      500: 261,
      600: 288,
      700: 311,
      800: 339,
      900: 361,
      1000: 386,
      1100: 412,
      1200: 436,
      1300: 464,
      1400: 487,
      1500: 514,
    },
    3200: {
      400: 237,
      500: 265,
      600: 293,
      700: 317,
      800: 343,
      900: 368,
      1000: 394,
      1100: 421,
      1200: 445,
      1300: 472,
      1400: 499,
      1500: 523,
    },
    3300: {
      400: 241,
      500: 270,
      600: 296,
      700: 323,
      800: 350,
      900: 376,
      1000: 403,
      1100: 431,
      1200: 454,
      1300: 481,
      1400: 507,
      1500: 536,
    },
    3400: {
      400: 244,
      500: 275,
      600: 302,
      700: 329,
      800: 356,
      900: 383,
      1000: 409,
      1100: 436,
      1200: 464,
      1300: 490,
      1400: 520,
      1500: 547,
    },
    3500: {
      400: 248,
      500: 278,
      600: 308,
      700: 335,
      800: 361,
      900: 389,
      1000: 419,
      1100: 445,
      1200: 472,
      1300: 502,
      1400: 530,
      1500: 556,
    },
    3600: {
      400: 252,
      500: 283,
      600: 311,
      700: 341,
      800: 368,
      900: 399,
      1000: 427,
      1100: 454,
      1200: 481,
      1300: 512,
      1400: 538,
      1500: 567,
    },
    3700: {
      400: 256,
      500: 288,
      600: 317,
      700: 347,
      800: 376,
      900: 403,
      1000: 434,
      1100: 464,
      1200: 490,
      1300: 520,
      1400: 550,
      1500: 577,
    },
    3800: {
      400: 259,
      500: 293,
      600: 323,
      700: 353,
      800: 383,
      900: 412,
      1000: 442,
      1100: 472,
      1200: 499,
      1300: 530,
      1400: 558,
      1500: 589,
    },
    3900: {
      400: 263,
      500: 298,
      600: 329,
      700: 359,
      800: 389,
      900: 419,
      1000: 448,
      1100: 478,
      1200: 507,
      1300: 538,
      1400: 571,
      1500: 600,
    },
    4000: {
      400: 271,
      500: 302,
      600: 331,
      700: 366,
      800: 394,
      900: 427,
      1000: 456,
      1100: 487,
      1200: 517,
      1300: 550,
      1400: 580,
      1500: 610,
    },
  },
  1: {
    800: {
      400: 149,
      500: 162,
      600: 177,
      700: 189,
      800: 197,
      900: 218,
      1000: 234,
      1100: 245,
      1200: 263,
      1300: 272,
      1400: 283,
      1500: 296,
    },
    900: {
      400: 152,
      500: 167,
      600: 179,
      700: 192,
      800: 206,
      900: 228,
      1000: 243,
      1100: 255,
      1200: 270,
      1300: 281,
      1400: 296,
      1500: 311,
    },
    1000: {
      400: 158,
      500: 175,
      600: 185,
      700: 201,
      800: 212,
      900: 237,
      1000: 252,
      1100: 265,
      1200: 281,
      1300: 296,
      1400: 308,
      1500: 323,
    },
    1100: {
      400: 163,
      500: 177,
      600: 192,
      700: 206,
      800: 222,
      900: 245,
      1000: 261,
      1100: 275,
      1200: 293,
      1300: 308,
      1400: 323,
      1500: 339,
    },
    1200: {
      400: 167,
      500: 183,
      600: 197,
      700: 212,
      800: 228,
      900: 255,
      1000: 270,
      1100: 288,
      1200: 302,
      1300: 321,
      1400: 335,
      1500: 353,
    },
    1300: {
      400: 172,
      500: 195,
      600: 212,
      700: 228,
      800: 243,
      900: 263,
      1000: 281,
      1100: 296,
      1200: 314,
      1300: 331,
      1400: 347,
      1500: 366,
    },
    1400: {
      400: 177,
      500: 201,
      600: 218,
      700: 237,
      800: 255,
      900: 272,
      1000: 290,
      1100: 308,
      1200: 326,
      1300: 343,
      1400: 361,
      1500: 379,
    },
    1500: {
      400: 182,
      500: 206,
      600: 224,
      700: 243,
      800: 263,
      900: 281,
      1000: 298,
      1100: 317,
      1200: 339,
      1300: 356,
      1400: 374,
      1500: 392,
    },
    1600: {
      400: 188,
      500: 210,
      600: 230,
      700: 252,
      800: 270,
      900: 290,
      1000: 308,
      1100: 329,
      1200: 347,
      1300: 368,
      1400: 386,
      1500: 407,
    },
    1700: {
      400: 192,
      500: 215,
      600: 237,
      700: 257,
      800: 278,
      900: 296,
      1000: 317,
      1100: 339,
      1200: 359,
      1300: 379,
      1400: 401,
      1500: 421,
    },
    1800: {
      400: 196,
      500: 222,
      600: 243,
      700: 263,
      800: 283,
      900: 308,
      1000: 326,
      1100: 350,
      1200: 370,
      1300: 392,
      1400: 412,
      1500: 434,
    },
    1900: {
      400: 201,
      500: 228,
      600: 248,
      700: 272,
      800: 293,
      900: 314,
      1000: 339,
      1100: 359,
      1200: 383,
      1300: 403,
      1400: 427,
      1500: 448,
    },
    2000: {
      400: 206,
      500: 234,
      600: 255,
      700: 278,
      800: 302,
      900: 323,
      1000: 347,
      1100: 370,
      1200: 392,
      1300: 416,
      1400: 439,
      1500: 460,
    },
    2100: {
      400: 211,
      500: 239,
      600: 263,
      700: 288,
      800: 311,
      900: 331,
      1000: 356,
      1100: 383,
      1200: 403,
      1300: 427,
      1400: 452,
      1500: 475,
    },
    2200: {
      400: 216,
      500: 243,
      600: 270,
      700: 293,
      800: 317,
      900: 341,
      1000: 368,
      1100: 392,
      1200: 416,
      1300: 442,
      1400: 467,
      1500: 490,
    },
    2300: {
      400: 221,
      500: 248,
      600: 275,
      700: 302,
      800: 326,
      900: 353,
      1000: 376,
      1100: 403,
      1200: 427,
      1300: 454,
      1400: 478,
      1500: 505,
    },
    2400: {
      400: 225,
      500: 255,
      600: 281,
      700: 308,
      800: 335,
      900: 361,
      1000: 386,
      1100: 412,
      1200: 439,
      1300: 467,
      1400: 493,
      1500: 517,
    },
    2500: {
      400: 230,
      500: 261,
      600: 288,
      700: 317,
      800: 341,
      900: 370,
      1000: 399,
      1100: 425,
      1200: 452,
      1300: 478,
      1400: 505,
      1500: 532,
    },
    2600: {
      400: 236,
      500: 265,
      600: 296,
      700: 323,
      800: 350,
      900: 379,
      1000: 407,
      1100: 436,
      1200: 464,
      1300: 490,
      1400: 520,
      1500: 547,
    },
    2700: {
      400: 239,
      500: 272,
      600: 302,
      700: 331,
      800: 359,
      900: 389,
      1000: 416,
      1100: 445,
      1200: 475,
      1300: 502,
      1400: 532,
      1500: 563,
    },
    2800: {
      400: 244,
      500: 278,
      600: 308,
      700: 339,
      800: 368,
      900: 399,
      1000: 427,
      1100: 456,
      1200: 487,
      1300: 517,
      1400: 547,
      1500: 577,
    },
    2900: {
      400: 249,
      500: 283,
      600: 314,
      700: 343,
      800: 376,
      900: 407,
      1000: 436,
      1100: 467,
      1200: 497,
      1300: 530,
      1400: 558,
      1500: 589,
    },
    3000: {
      400: 255,
      500: 290,
      600: 323,
      700: 353,
      800: 383,
      900: 416,
      1000: 445,
      1100: 478,
      1200: 507,
      1300: 540,
      1400: 571,
      1500: 603,
    },
    3100: {
      400: 259,
      500: 296,
      600: 329,
      700: 359,
      800: 392,
      900: 425,
      1000: 456,
      1100: 490,
      1200: 520,
      1300: 553,
      1400: 585,
      1500: 618,
    },
    3200: {
      400: 263,
      500: 302,
      600: 335,
      700: 368,
      800: 401,
      900: 434,
      1000: 467,
      1100: 499,
      1200: 532,
      1300: 565,
      1400: 598,
      1500: 631,
    },
    3300: {
      400: 269,
      500: 308,
      600: 341,
      700: 374,
      800: 409,
      900: 442,
      1000: 475,
      1100: 512,
      1200: 545,
      1300: 577,
      1400: 612,
      1500: 645,
    },
    3400: {
      400: 274,
      500: 314,
      600: 347,
      700: 383,
      800: 416,
      900: 452,
      1000: 487,
      1100: 520,
      1200: 556,
      1300: 591,
      1400: 624,
      1500: 661,
    },
    3500: {
      400: 278,
      500: 317,
      600: 353,
      700: 389,
      800: 425,
      900: 460,
      1000: 497,
      1100: 532,
      1200: 567,
      1300: 603,
      1400: 639,
      1500: 676,
    },
    3600: {
      400: 283,
      500: 323,
      600: 361,
      700: 399,
      800: 434,
      900: 469,
      1000: 505,
      1100: 545,
      1200: 580,
      1300: 616,
      1400: 651,
      1500: 686,
    },
    3700: {
      400: 288,
      500: 329,
      600: 368,
      700: 403,
      800: 442,
      900: 478,
      1000: 517,
      1100: 553,
      1200: 591,
      1300: 628,
      1400: 666,
      1500: 702,
    },
    3800: {
      400: 293,
      500: 335,
      600: 374,
      700: 412,
      800: 452,
      900: 487,
      1000: 525,
      1100: 565,
      1200: 600,
      1300: 639,
      1400: 678,
      1500: 717,
    },
    3900: {
      400: 297,
      500: 341,
      600: 379,
      700: 419,
      800: 456,
      900: 497,
      1000: 536,
      1100: 577,
      1200: 612,
      1300: 651,
      1400: 691,
      1500: 729,
    },
    4000: {
      400: 307,
      500: 347,
      600: 386,
      700: 427,
      800: 467,
      900: 505,
      1000: 547,
      1100: 585,
      1200: 624,
      1300: 666,
      1400: 704,
      1500: 744,
    },
  },
  2: {
    800: {
      400: 158,
      500: 175,
      600: 189,
      700: 201,
      800: 215,
      900: 239,
      1000: 255,
      1100: 270,
      1200: 283,
      1300: 298,
      1400: 314,
      1500: 329,
    },
    900: {
      400: 164,
      500: 179,
      600: 195,
      700: 210,
      800: 224,
      900: 252,
      1000: 265,
      1100: 283,
      1200: 298,
      1300: 317,
      1400: 331,
      1500: 347,
    },
    1000: {
      400: 171,
      500: 185,
      600: 201,
      700: 218,
      800: 234,
      900: 263,
      1000: 278,
      1100: 296,
      1200: 314,
      1300: 331,
      1400: 347,
      1500: 366,
    },
    1100: {
      400: 176,
      500: 192,
      600: 206,
      700: 224,
      800: 243,
      900: 272,
      1000: 293,
      1100: 311,
      1200: 329,
      1300: 347,
      1400: 366,
      1500: 383,
    },
    1200: {
      400: 182,
      500: 197,
      600: 215,
      700: 234,
      800: 252,
      900: 283,
      1000: 306,
      1100: 323,
      1200: 343,
      1300: 361,
      1400: 383,
      1500: 401,
    },
    1300: {
      400: 188,
      500: 215,
      600: 234,
      700: 255,
      800: 275,
      900: 296,
      1000: 317,
      1100: 339,
      1200: 359,
      1300: 376,
      1400: 399,
      1500: 419,
    },
    1400: {
      400: 193,
      500: 218,
      600: 243,
      700: 263,
      800: 283,
      900: 308,
      1000: 329,
      1100: 350,
      1200: 370,
      1300: 394,
      1400: 416,
      1500: 436,
    },
    1500: {
      400: 199,
      500: 228,
      600: 248,
      700: 272,
      800: 296,
      900: 317,
      1000: 341,
      1100: 366,
      1200: 386,
      1300: 409,
      1400: 434,
      1500: 456,
    },
    1600: {
      400: 205,
      500: 234,
      600: 257,
      700: 281,
      800: 306,
      900: 329,
      1000: 353,
      1100: 376,
      1200: 401,
      1300: 425,
      1400: 448,
      1500: 472,
    },
    1700: {
      400: 211,
      500: 239,
      600: 265,
      700: 290,
      800: 317,
      900: 341,
      1000: 366,
      1100: 392,
      1200: 416,
      1300: 442,
      1400: 467,
      1500: 490,
    },
    1800: {
      400: 217,
      500: 248,
      600: 272,
      700: 298,
      800: 326,
      900: 353,
      1000: 376,
      1100: 403,
      1200: 431,
      1300: 456,
      1400: 485,
      1500: 512,
    },
    1900: {
      400: 223,
      500: 255,
      600: 281,
      700: 308,
      800: 335,
      900: 361,
      1000: 392,
      1100: 419,
      1200: 445,
      1300: 472,
      1400: 499,
      1500: 525,
    },
    2000: {
      400: 229,
      500: 261,
      600: 290,
      700: 317,
      800: 347,
      900: 374,
      1000: 403,
      1100: 431,
      1200: 460,
      1300: 490,
      1400: 517,
      1500: 547,
    },
    2100: {
      400: 234,
      500: 265,
      600: 296,
      700: 326,
      800: 356,
      900: 386,
      1000: 416,
      1100: 445,
      1200: 475,
      1300: 505,
      1400: 536,
      1500: 565,
    },
    2200: {
      400: 241,
      500: 275,
      600: 306,
      700: 339,
      800: 368,
      900: 399,
      1000: 427,
      1100: 460,
      1200: 490,
      1300: 520,
      1400: 553,
      1500: 583,
    },
    2300: {
      400: 247,
      500: 281,
      600: 314,
      700: 347,
      800: 376,
      900: 409,
      1000: 442,
      1100: 472,
      1200: 505,
      1300: 538,
      1400: 567,
      1500: 600,
    },
    2400: {
      400: 252,
      500: 290,
      600: 323,
      700: 356,
      800: 389,
      900: 421,
      1000: 454,
      1100: 487,
      1200: 520,
      1300: 553,
      1400: 585,
      1500: 618,
    },
    2500: {
      400: 258,
      500: 296,
      600: 331,
      700: 366,
      800: 399,
      900: 434,
      1000: 467,
      1100: 502,
      1200: 536,
      1300: 571,
      1400: 603,
      1500: 636,
    },
    2600: {
      400: 264,
      500: 302,
      600: 339,
      700: 374,
      800: 409,
      900: 445,
      1000: 481,
      1100: 514,
      1200: 550,
      1300: 585,
      1400: 622,
      1500: 653,
    },
    2700: {
      400: 270,
      500: 311,
      600: 347,
      700: 383,
      800: 419,
      900: 456,
      1000: 493,
      1100: 530,
      1200: 565,
      1300: 600,
      1400: 636,
      1500: 676,
    },
    2800: {
      400: 276,
      500: 317,
      600: 356,
      700: 392,
      800: 431,
      900: 467,
      1000: 505,
      1100: 545,
      1200: 580,
      1300: 618,
      1400: 653,
      1500: 694,
    },
    2900: {
      400: 282,
      500: 326,
      600: 361,
      700: 401,
      800: 442,
      900: 478,
      1000: 517,
      1100: 556,
      1200: 594,
      1300: 633,
      1400: 671,
      1500: 711,
    },
    3000: {
      400: 288,
      500: 331,
      600: 370,
      700: 412,
      800: 452,
      900: 490,
      1000: 532,
      1100: 571,
      1200: 610,
      1300: 651,
      1400: 691,
      1500: 729,
    },
    3100: {
      400: 294,
      500: 339,
      600: 379,
      700: 421,
      800: 460,
      900: 502,
      1000: 545,
      1100: 585,
      1200: 624,
      1300: 666,
      1400: 704,
      1500: 747,
    },
    3200: {
      400: 298,
      500: 347,
      600: 389,
      700: 431,
      800: 472,
      900: 514,
      1000: 556,
      1100: 598,
      1200: 639,
      1300: 681,
      1400: 723,
      1500: 764,
    },
    3300: {
      400: 317,
      500: 368,
      600: 412,
      700: 456,
      800: 505,
      900: 550,
      1000: 594,
      1100: 639,
      1200: 684,
      1300: 729,
      1400: 774,
      1500: 822,
    },
    3400: {
      400: 306,
      500: 353,
      600: 399,
      700: 439,
      800: 481,
      900: 525,
      1000: 567,
      1100: 612,
      1200: 653,
      1300: 699,
      1400: 741,
      1500: 786,
    },
    3500: {
      400: 323,
      500: 374,
      600: 421,
      700: 467,
      800: 514,
      900: 563,
      1000: 606,
      1100: 653,
      1200: 699,
      1300: 747,
      1400: 791,
      1500: 840,
    },
    3600: {
      400: 311,
      500: 361,
      600: 403,
      700: 448,
      800: 493,
      900: 538,
      1000: 580,
      1100: 624,
      1200: 669,
      1300: 714,
      1400: 758,
      1500: 804,
    },
    3700: {
      400: 329,
      500: 383,
      600: 431,
      700: 475,
      800: 525,
      900: 571,
      1000: 622,
      1100: 666,
      1200: 714,
      1300: 762,
      1400: 809,
      1500: 858,
    },
    3800: {
      400: 335,
      500: 389,
      600: 436,
      700: 487,
      800: 536,
      900: 583,
      1000: 633,
      1100: 681,
      1200: 729,
      1300: 780,
      1400: 827,
      1500: 875,
    },
    3900: {
      400: 341,
      500: 399,
      600: 445,
      700: 497,
      800: 547,
      900: 594,
      1000: 645,
      1100: 696,
      1200: 744,
      1300: 795,
      1400: 845,
      1500: 893,
    },
    4000: {
      400: 353,
      500: 403,
      600: 454,
      700: 505,
      800: 556,
      900: 606,
      1000: 658,
      1100: 709,
      1200: 758,
      1300: 809,
      1400: 860,
      1500: 913,
    },
  },
  3: {
    800: {
      400: 164,
      500: 183,
      600: 197,
      700: 215,
      800: 230,
      900: 261,
      1000: 278,
      1100: 293,
      1200: 311,
      1300: 329,
      1400: 347,
      1500: 366,
    },
    900: {
      400: 172,
      500: 189,
      600: 206,
      700: 224,
      800: 243,
      900: 272,
      1000: 293,
      1100: 311,
      1200: 329,
      1300: 347,
      1400: 368,
      1500: 386,
    },
    1000: {
      400: 178,
      500: 197,
      600: 215,
      700: 234,
      800: 252,
      900: 288,
      1000: 308,
      1100: 326,
      1200: 347,
      1300: 368,
      1400: 389,
      1500: 407,
    },
    1100: {
      400: 185,
      500: 204,
      600: 224,
      700: 243,
      800: 263,
      900: 302,
      1000: 323,
      1100: 343,
      1200: 366,
      1300: 386,
      1400: 409,
      1500: 431,
    },
    1200: {
      400: 192,
      500: 212,
      600: 234,
      700: 252,
      800: 272,
      900: 314,
      1000: 339,
      1100: 361,
      1200: 383,
      1300: 407,
      1400: 431,
      1500: 452,
    },
    1300: {
      400: 199,
      500: 230,
      600: 255,
      700: 278,
      800: 306,
      900: 329,
      1000: 353,
      1100: 376,
      1200: 401,
      1300: 427,
      1400: 452,
      1500: 475,
    },
    1400: {
      400: 208,
      500: 239,
      600: 265,
      700: 290,
      800: 317,
      900: 341,
      1000: 368,
      1100: 394,
      1200: 419,
      1300: 445,
      1400: 472,
      1500: 497,
    },
    1500: {
      400: 213,
      500: 248,
      600: 275,
      700: 302,
      800: 329,
      900: 356,
      1000: 383,
      1100: 409,
      1200: 442,
      1300: 464,
      1400: 490,
      1500: 520,
    },
    1600: {
      400: 222,
      500: 255,
      600: 283,
      700: 311,
      800: 341,
      900: 370,
      1000: 399,
      1100: 427,
      1200: 454,
      1300: 485,
      1400: 512,
      1500: 540,
    },
    1700: {
      400: 228,
      500: 263,
      600: 293,
      700: 323,
      800: 353,
      900: 383,
      1000: 412,
      1100: 442,
      1200: 472,
      1300: 502,
      1400: 532,
      1500: 563,
    },
    1800: {
      400: 236,
      500: 272,
      600: 302,
      700: 335,
      800: 366,
      900: 399,
      1000: 427,
      1100: 460,
      1200: 490,
      1300: 523,
      1400: 553,
      1500: 585,
    },
    1900: {
      400: 242,
      500: 281,
      600: 311,
      700: 347,
      800: 376,
      900: 412,
      1000: 442,
      1100: 475,
      1200: 507,
      1300: 540,
      1400: 573,
      1500: 606,
    },
    2000: {
      400: 249,
      500: 288,
      600: 323,
      700: 356,
      800: 392,
      900: 425,
      1000: 460,
      1100: 493,
      1200: 525,
      1300: 563,
      1400: 594,
      1500: 631,
    },
    2100: {
      400: 257,
      500: 296,
      600: 331,
      700: 368,
      800: 403,
      900: 439,
      1000: 475,
      1100: 512,
      1200: 547,
      1300: 580,
      1400: 616,
      1500: 651,
    },
    2200: {
      400: 263,
      500: 306,
      600: 341,
      700: 379,
      800: 416,
      900: 454,
      1000: 490,
      1100: 525,
      1200: 565,
      1300: 600,
      1400: 639,
      1500: 676,
    },
    2300: {
      400: 271,
      500: 314,
      600: 353,
      700: 392,
      800: 431,
      900: 467,
      1000: 505,
      1100: 545,
      1200: 583,
      1300: 622,
      1400: 661,
      1500: 696,
    },
    2400: {
      400: 277,
      500: 323,
      600: 361,
      700: 401,
      800: 442,
      900: 481,
      1000: 520,
      1100: 563,
      1200: 600,
      1300: 639,
      1400: 681,
      1500: 720,
    },
    2500: {
      400: 285,
      500: 331,
      600: 370,
      700: 412,
      800: 454,
      900: 497,
      1000: 538,
      1100: 577,
      1200: 618,
      1300: 661,
      1400: 702,
      1500: 744,
    },
    2600: {
      400: 291,
      500: 341,
      600: 383,
      700: 425,
      800: 467,
      900: 512,
      1000: 553,
      1100: 594,
      1200: 636,
      1300: 681,
      1400: 723,
      1500: 764,
    },
    2700: {
      400: 298,
      500: 347,
      600: 392,
      700: 436,
      800: 481,
      900: 523,
      1000: 567,
      1100: 612,
      1200: 653,
      1300: 699,
      1400: 744,
      1500: 789,
    },
    2800: {
      400: 307,
      500: 356,
      600: 401,
      700: 448,
      800: 493,
      900: 538,
      1000: 583,
      1100: 628,
      1200: 676,
      1300: 720,
      1400: 764,
      1500: 809,
    },
    2900: {
      400: 313,
      500: 366,
      600: 412,
      700: 456,
      800: 505,
      900: 553,
      1000: 600,
      1100: 645,
      1200: 694,
      1300: 741,
      1400: 786,
      1500: 833,
    },
    3000: {
      400: 321,
      500: 374,
      600: 421,
      700: 469,
      800: 517,
      900: 565,
      1000: 616,
      1100: 663,
      1200: 711,
      1300: 758,
      1400: 807,
      1500: 855,
    },
    3100: {
      400: 327,
      500: 383,
      600: 431,
      700: 481,
      800: 532,
      900: 580,
      1000: 631,
      1100: 681,
      1200: 729,
      1300: 780,
      1400: 827,
      1500: 878,
    },
    3200: {
      400: 335,
      500: 392,
      600: 442,
      700: 493,
      800: 545,
      900: 594,
      1000: 645,
      1100: 696,
      1200: 747,
      1300: 797,
      1400: 848,
      1500: 899,
    },
    3300: {
      400: 341,
      500: 401,
      600: 452,
      700: 505,
      800: 556,
      900: 610,
      1000: 661,
      1100: 714,
      1200: 764,
      1300: 817,
      1400: 869,
      1500: 924,
    },
    3400: {
      400: 348,
      500: 407,
      600: 460,
      700: 517,
      800: 571,
      900: 622,
      1000: 676,
      1100: 729,
      1200: 786,
      1300: 840,
      1400: 891,
      1500: 944,
    },
    3500: {
      400: 356,
      500: 416,
      600: 472,
      700: 525,
      800: 583,
      900: 636,
      1000: 694,
      1100: 747,
      1200: 804,
      1300: 858,
      1400: 913,
      1500: 968,
    },
    3600: {
      400: 362,
      500: 425,
      600: 481,
      700: 538,
      800: 594,
      900: 651,
      1000: 709,
      1100: 764,
      1200: 822,
      1300: 878,
      1400: 935,
      1500: 988,
    },
    3700: {
      400: 370,
      500: 434,
      600: 490,
      700: 550,
      800: 606,
      900: 666,
      1000: 723,
      1100: 780,
      1200: 840,
      1300: 895,
      1400: 955,
      1500: 1012,
    },
    3800: {
      400: 376,
      500: 442,
      600: 502,
      700: 563,
      800: 622,
      900: 681,
      1000: 737,
      1100: 797,
      1200: 858,
      1300: 918,
      1400: 977,
      1500: 1037,
    },
    3900: {
      400: 385,
      500: 452,
      600: 512,
      700: 571,
      800: 633,
      900: 694,
      1000: 756,
      1100: 815,
      1200: 875,
      1300: 938,
      1400: 997,
      1500: 1057,
    },
    4000: {
      400: 399,
      500: 460,
      600: 520,
      700: 583,
      800: 645,
      900: 709,
      1000: 771,
      1100: 833,
      1200: 893,
      1300: 955,
      1400: 1019,
      1500: 1082,
    },
  },
  4: {
    800: {
      400: 189,
      500: 210,
      600: 227,
      700: 247,
      800: 265,
      900: 300,
      1000: 320,
      1100: 336,
      1200: 358,
      1300: 378,
      1400: 399,
      1500: 421,
    },
    900: {
      400: 198,
      500: 217,
      600: 237,
      700: 258,
      800: 279,
      900: 313,
      1000: 336,
      1100: 358,
      1200: 378,
      1300: 399,
      1400: 423,
      1500: 444,
    },
    1000: {
      400: 205,
      500: 227,
      600: 247,
      700: 269,
      800: 290,
      900: 331,
      1000: 354,
      1100: 374,
      1200: 399,
      1300: 423,
      1400: 448,
      1500: 468,
    },
    1100: {
      400: 213,
      500: 235,
      600: 258,
      700: 279,
      800: 302,
      900: 347,
      1000: 372,
      1100: 395,
      1200: 421,
      1300: 444,
      1400: 471,
      1500: 495,
    },
    1200: {
      400: 221,
      500: 244,
      600: 269,
      700: 290,
      800: 313,
      900: 361,
      1000: 389,
      1100: 415,
      1200: 441,
      1300: 468,
      1400: 495,
      1500: 520,
    },
    1300: {
      400: 229,
      500: 265,
      600: 293,
      700: 320,
      800: 351,
      900: 378,
      1000: 406,
      1100: 433,
      1200: 461,
      1300: 491,
      1400: 520,
      1500: 547,
    },
    1400: {
      400: 239,
      500: 275,
      600: 305,
      700: 334,
      800: 365,
      900: 392,
      1000: 423,
      1100: 453,
      1200: 482,
      1300: 511,
      1400: 543,
      1500: 571,
    },
    1500: {
      400: 246,
      500: 285,
      600: 316,
      700: 347,
      800: 378,
      900: 410,
      1000: 441,
      1100: 471,
      1200: 509,
      1300: 533,
      1400: 563,
      1500: 598,
    },
    1600: {
      400: 255,
      500: 293,
      600: 326,
      700: 358,
      800: 392,
      900: 426,
      1000: 458,
      1100: 491,
      1200: 522,
      1300: 558,
      1400: 589,
      1500: 621,
    },
    1700: {
      400: 262,
      500: 302,
      600: 336,
      700: 372,
      800: 406,
      900: 441,
      1000: 473,
      1100: 509,
      1200: 543,
      1300: 578,
      1400: 612,
      1500: 647,
    },
    1800: {
      400: 271,
      500: 313,
      600: 347,
      700: 385,
      800: 421,
      900: 458,
      1000: 491,
      1100: 529,
      1200: 563,
      1300: 601,
      1400: 636,
      1500: 673,
    },
    1900: {
      400: 278,
      500: 323,
      600: 358,
      700: 399,
      800: 433,
      900: 473,
      1000: 509,
      1100: 547,
      1200: 583,
      1300: 621,
      1400: 659,
      1500: 697,
    },
    2000: {
      400: 286,
      500: 331,
      600: 372,
      700: 410,
      800: 450,
      900: 488,
      1000: 529,
      1100: 567,
      1200: 604,
      1300: 647,
      1400: 684,
      1500: 726,
    },
    2100: {
      400: 296,
      500: 340,
      600: 381,
      700: 423,
      800: 464,
      900: 505,
      1000: 547,
      1100: 589,
      1200: 629,
      1300: 667,
      1400: 708,
      1500: 749,
    },
    2200: {
      400: 302,
      500: 351,
      600: 392,
      700: 435,
      800: 479,
      900: 522,
      1000: 563,
      1100: 604,
      1200: 650,
      1300: 690,
      1400: 735,
      1500: 777,
    },
    2300: {
      400: 312,
      500: 361,
      600: 406,
      700: 450,
      800: 495,
      900: 537,
      1000: 581,
      1100: 627,
      1200: 670,
      1300: 715,
      1400: 760,
      1500: 800,
    },
    2400: {
      400: 319,
      500: 372,
      600: 415,
      700: 461,
      800: 509,
      900: 553,
      1000: 598,
      1100: 647,
      1200: 690,
      1300: 735,
      1400: 783,
      1500: 827,
    },
    2500: {
      400: 328,
      500: 381,
      600: 426,
      700: 473,
      800: 522,
      900: 571,
      1000: 619,
      1100: 663,
      1200: 711,
      1300: 760,
      1400: 807,
      1500: 856,
    },
    2600: {
      400: 335,
      500: 392,
      600: 441,
      700: 488,
      800: 537,
      900: 589,
      1000: 636,
      1100: 684,
      1200: 731,
      1300: 783,
      1400: 832,
      1500: 879,
    },
    2700: {
      400: 343,
      500: 399,
      600: 450,
      700: 502,
      800: 553,
      900: 601,
      1000: 652,
      1100: 704,
      1200: 751,
      1300: 804,
      1400: 856,
      1500: 907,
    },
    2800: {
      400: 353,
      500: 410,
      600: 461,
      700: 515,
      800: 567,
      900: 619,
      1000: 670,
      1100: 722,
      1200: 777,
      1300: 827,
      1400: 879,
      1500: 931,
    },
    2900: {
      400: 359,
      500: 421,
      600: 473,
      700: 525,
      800: 581,
      900: 636,
      1000: 690,
      1100: 742,
      1200: 798,
      1300: 852,
      1400: 903,
      1500: 958,
    },
    3000: {
      400: 369,
      500: 430,
      600: 484,
      700: 540,
      800: 594,
      900: 650,
      1000: 708,
      1100: 762,
      1200: 818,
      1300: 872,
      1400: 928,
      1500: 983,
    },
    3100: {
      400: 376,
      500: 441,
      600: 495,
      700: 553,
      800: 612,
      900: 667,
      1000: 726,
      1100: 783,
      1200: 838,
      1300: 897,
      1400: 951,
      1500: 1009,
    },
    3200: {
      400: 385,
      500: 450,
      600: 509,
      700: 567,
      800: 627,
      900: 684,
      1000: 742,
      1100: 800,
      1200: 859,
      1300: 917,
      1400: 975,
      1500: 1034,
    },
    3300: {
      400: 392,
      500: 461,
      600: 520,
      700: 581,
      800: 639,
      900: 701,
      1000: 760,
      1100: 821,
      1200: 879,
      1300: 940,
      1400: 1000,
      1500: 1062,
    },
    3400: {
      400: 400,
      500: 468,
      600: 529,
      700: 594,
      800: 657,
      900: 715,
      1000: 777,
      1100: 838,
      1200: 903,
      1300: 966,
      1400: 1024,
      1500: 1085,
    },
    3500: {
      400: 410,
      500: 479,
      600: 543,
      700: 604,
      800: 670,
      900: 731,
      1000: 798,
      1100: 859,
      1200: 925,
      1300: 986,
      1400: 1050,
      1500: 1114,
    },
    3600: {
      400: 416,
      500: 488,
      600: 553,
      700: 619,
      800: 684,
      900: 749,
      1000: 815,
      1100: 879,
      1200: 945,
      1300: 1009,
      1400: 1076,
      1500: 1137,
    },
    3700: {
      400: 426,
      500: 499,
      600: 563,
      700: 632,
      800: 697,
      900: 766,
      1000: 832,
      1100: 897,
      1200: 966,
      1300: 1030,
      1400: 1099,
      1500: 1164,
    },
    3800: {
      400: 433,
      500: 509,
      600: 578,
      700: 647,
      800: 715,
      900: 783,
      1000: 848,
      1100: 917,
      1200: 986,
      1300: 1055,
      1400: 1123,
      1500: 1192,
    },
    3900: {
      400: 442,
      500: 520,
      600: 589,
      700: 657,
      800: 728,
      900: 798,
      1000: 870,
      1100: 937,
      1200: 1007,
      1300: 1078,
      1400: 1146,
      1500: 1215,
    },
    4000: {
      400: 458,
      500: 529,
      600: 598,
      700: 670,
      800: 742,
      900: 815,
      1000: 887,
      1100: 958,
      1200: 1027,
      1300: 1099,
      1400: 1172,
      1500: 1244,
      },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.SkyProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createSkyElements...");
    createSkyElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createSkyElements() {
    // Etsi sopiva paikka elementeille
    const productForm =
      document.querySelector(".product-form") ||
      document.querySelector(".product__info-wrapper") ||
      document.body;

    // Luo pääkontaineri
    let configurator = document.getElementById("sky-configurator");
    if (!configurator) {
      configurator = document.createElement("div");
      configurator.id = "sky-configurator";
      configurator.className = "sky-configurator";
      productForm.appendChild(configurator);
    }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 800" max="1500" min="300" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 3000" max="4000" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit SKY profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
`;

    const options = document.createElement("div");
    options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      option.innerHTML = `
    <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
    <span class="profile-option-text">${profile.name}</span>
  `;

      option.addEventListener("click", function () {
        selectedProfile = key;
        selected.innerHTML = `
      <span class="dropdown-selected-content">
        <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
        ${profile.name}
      </span>
      <span class="dropdown-arrow">▼</span>
    `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 190.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 190.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        1500
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 800),
        4000
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 190.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 800; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 190.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 190 €
        const finalPrice = Math.max(roundedPrice, 190);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "block";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 300) {
      errors.width = true;
      messages.width = "Min 300mm";
    } else if (width > 1500) {
      errors.width = true;
      messages.width = "Max 1500mm";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 4000) {
      errors.height = true;
      messages.height = "Max 4000mm";
    }

    if (width * height > 6000000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 6,0 m²";
      messages.height = "Max 6,0 m²";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "block";
        return false;
      }
    }

    return true;
  }

    function createAddToCartButton() {
  // Tarkista onko nappi jo olemassa
  let existingButton = document.getElementById("sky-add-to-cart");
  if (existingButton) {
    existingButton.style.display = "block";
    return;
  }

  // Luo uusi nappi
  const addToCartButton = document.createElement("button");
  addToCartButton.id = "sky-add-to-cart";
  addToCartButton.type = "button";
  addToCartButton.textContent = "Lisää ostoskoriin";
  addToCartButton.className = "sky-add-to-cart-button";

  // UUSI: Cart API -pohjainen lisäys
  addToCartButton.addEventListener("click", function () {
    // Kerää tiedot
    const width = parseInt(widthInput.value);
    const height = parseInt(heightInput.value);
    const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
    const profileName = getProfilesForProduct()[selectedProfile].name;
    
    // Hae kangasväri
    const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
    const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
    
    // Perustuotteen hinta
    const basePrice = 189.00;
    
    // Laske korotus
    const priceAdjustment = calculatedPriceValue - basePrice;
    
    // Luo unique ID tälle tuoteparille
    const pairId = Date.now().toString();
    
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
    const formData = {
      items: []
    };
    
    // Lisää räätälöinti AINA (jos hinta > 0)
    const adjustmentQuantity = Math.max(1, Math.round(priceAdjustment));
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
    
    // Lisää perustuote TOISENA
    formData.items.push({
      id: config.variantIds.base,
      quantity: 1,
      properties: {
        '_pair_id': pairId,
        '_pair_order': '1'
      }
    });
    
    // Lähetä Cart API:lle
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Päivitä ostoskori
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
    });
  });

  // Lisää hinta-osion jälkeen
  if (priceDisplay) {
    priceDisplay.appendChild(addToCartButton);
  }
  
  console.log("Add to cart button created");
}

  // Varmista hinnan päivitys kaikissa tilanteissa
  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 6,0 m²
      if (parseFloat(area) > 6.0) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

    // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});